export const Boxing = [
    {
        "id": 0,
        "Title": "IES-2024-0",
        "ImageSource": "/Boxing/BoxingGloves/0.jpeg",
        "Category": "Bag Gloves"
    },
    {
        "id": 1,
        "Title": "IES-2024-1",
        "ImageSource": "/Boxing/BoxingGloves/1.jpeg",
        "Category": "Bag Gloves"
    },
    {
        "id": 2,
        "Title": "IES-2024-2",
        "ImageSource": "/Boxing/BoxingGloves/2.jpeg",
        "Category": "Bag Gloves"
    },
    {
        "id": 3,
        "Title": "IES-2024-3",
        "ImageSource": "/Boxing/BoxingGloves/3.jpeg",
        "Category": "Bag Gloves"
    },
    {
        "id": 4,
        "Title": "IES-2024-4",
        "ImageSource": "/Boxing/BoxingGloves/4.jpeg",
        "Category": "Bag Gloves"
    },
]